import { Star } from 'lucide-react';

const StarRating = ({ rating, onRatingChange = null, size = 20, readonly = false }) => {
  const stars = [1, 2, 3, 4, 5];
  
  const handleClick = (value) => {
    if (!readonly && onRatingChange) {
      onRatingChange(value);
    }
  };

  return (
    <div className="flex items-center space-x-1">
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => handleClick(star)}
          disabled={readonly}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition`}
        >
          <Star
            size={size}
            className={`${
              star <= rating
                ? 'fill-yellow-500 text-yellow-500'
                : 'text-gray-400'
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;